import { IAvisEditableListFieldArrayProps } from "../../../types";
import { AvisEditableListAddButton } from "../../actions/AvisEditableListAddButton";
import { AvisEditableListFooterCell } from "./";

export function AvisEditableListFooterRow<T extends object, P extends object>(
  props: Readonly<IAvisEditableListFieldArrayProps<T, P>>,
) {
  const { fields, bag, bagField } = props;

  const rowCount = (bag.values[bagField] as []).length;

  return (
    <tr className="avis-editable-list-footer-row">
      <th className="actions">
        {rowCount > 5 ? <AvisEditableListAddButton {...props} /> : <></>}
      </th>
      {fields.map((f) => (
        <AvisEditableListFooterCell key={f.name.toString()} />
      ))}
    </tr>
  );
}
